import { CustomUserDetails } from 'src/app/shared/extends/models/extended.models';
import { RunningEnvResponse, UserPoolInfo, UserPoolPrecis } from 'src/app/shared/auto-generated-devumconsole/models/auto-generated-models';



export abstract class SessionStorageProvider {

  abstract getRunningEnv(): RunningEnvResponse;
  abstract setRunningEnv(enumValues: RunningEnvResponse): void;

  abstract getCognitoToken(): string;
  abstract setCognitoToken(data: string): void;

  abstract getLogInInfo(): boolean;
  abstract setLogInInfo(data: boolean): void;

  abstract getUserProfile(): CustomUserDetails;
  abstract setUserProfile(data: CustomUserDetails): void;

  abstract getCognitoProfile(): any;
  abstract setCognitoProfile(data: any): void;

  abstract getAuthState(): any;
  abstract setAuthState(data: any): void;

  // abstract getModuleDeployment(): ModuleDeployment[];
  // abstract setModuleDeployment(data: ModuleDeployment[]): void;

  abstract getCurrencyConverter(): any;
  abstract setCurrencyConverter(data: any): void;

  abstract getUserPool(): UserPoolPrecis;
  abstract setUserPool(data: UserPoolPrecis): void;

  abstract getDbKey(): string;
  abstract setDbKey(data: string): void;

  abstract getIsInfraRegistered(): boolean;
  abstract setIsInfraRegistered(data: boolean): void;

  abstract getIsAgentInstalled(): boolean;
  abstract setIsAgentInstalled(data: boolean): void;

  abstract clearSession(): void;

  abstract getRegion(): string;
  abstract setRegion(data: string): void;

  abstract getDataCenterRegion(): string;
  abstract setDataCenterRegion(data: string): void;

}
